import styled from 'styled-components';

export const FilterOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  height: 160px;
  padding-left: 8px;
`;

export const FilterOptionsHeading = styled.span`
  color: white !important;
  font-size: 13px;
`;
